<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <template v-if="visitor.personal.nationality_id != 182">
      <input
        v-model="inputValue"
        :id="inputId"
        :data-selected="visitor.personal.dataSelected"
        :disabled="disabled"
        autocomplete="off"
        class="form-control"
        @change="emit"
        @input="emit"
        @blur="emit"
        @keyup.enter="emit"
        @keyup.delete="emit"
      />
    </template>
    <template v-else>
      <input
        v-model="inputValue"
        :id="inputId"
        :data-selected="visitor.personal.dataSelected"
        :disabled="disabled"
        autocomplete="off"
        class="form-control"
        @change="emit"
        @input="emit"
        @blur="emit"
        @keyup.enter="emit"
        @keyup.delete="emit"
      />
      <typeahead
        v-model="inputValue"
        :async-function="typeahead"
        :data="typeaheadData"
        :item-key="typeaheadItemKey"
        :limit="typeaheadLimit"
        :target="'#' + inputId"
        @input="selectTypeahead"
      />
    </template>
      <div v-if="!isView">
        <div style="margin-top: 5px" v-if="visitor.personalUnits && visitor.personalUnits.length > 1 && visitor.personal.nationality_id === 182">
          <div
            v-for="(personalUnit, index) in visitor.personalUnits"
            :key="index"
            class="overflow-ellipsis-text"
          >
            <a
              @click="setIdentificationPlace(personalUnit)"
              :title="personalUnit"
              class="transport-owner-helpers"
            >{{ personalUnit }}</a>
          </div>
        </div>
        <div style="margin-top: 5px" v-else-if="documentHelpText !== null && visitor.personal.nationality_id !== 182">
          <div
            v-for="(helpText, index) in documentHelpText"
            :key="index"
            class="overflow-ellipsis-text">
            <a
              :title="helpText"
              class="transport-owner-helpers"
              @click="setIdentificationPlace(helpText)"
            >{{ helpText }}</a>
          </div>
        </div>
      </div>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'IdentificationPlaceInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Кем выдан'
    },

    inputName: {
      default: 'identification_place'
    },

    inputHint: {
      default: undefined
    },

    typeaheadItemKey: {
      default: 'full_name'
    },

    visitor: {
      default: {}
    },

    documentMasks: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    inputId() {
      let inputId = `form-visitor-identification-place-${this.visitorIndex}`
      if (this.transportIndex !== null) {
        return `form-visitor-transport-${this.transportIndex}-driver-${this.visitorIndex}-identification-place`
      }

      return inputId
    },

    documentHelpText() {
      return this.getDocumentPatternData(this.visitor, 'authority')?.split('; ')
    }
  },

  methods: {
    setIdentificationPlace(identificationPlace) {
      this.visitor.personal.identification_place = identificationPlace
    },

    getDocumentPatternData(visitor, type) {
      const result = this.documentMasks.find(mask => (Number(mask.nationality_id) === Number(visitor.personal.nationality_id) || mask.nationality_id == null) && mask.identification_id === visitor.personal.identification_id)

      return result && Object.prototype.hasOwnProperty.call(result, type) ? result[type] : null
    }
  }
}
</script>
